module.exports = __webpack_public_path__ + "img/Zain-Jordan-En-portrait.6d271fbf.png";